export default "__VITE_ASSET__OmiF57eF__"